export default __webpack_public_path__ + "8902dc9f796ca0f860bca5718609e005.png";